'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
import { getPrimaryPalette, calibrateDark, calibrateLight } from "./getPrimaryPalette.js";
import { getLightness } from "./getLightness.js";
const getPrimarySafePalette = (primaryColor, primaryPalette) => {
  const lightness = getLightness(primaryColor);
  if (lightness >= 95)
    return getPrimaryPalette(
      tinycolor(primaryColor).darken(calibrateDark(lightness, 0.42)).toHexString(),
      { lightest: primaryColor }
    );
  if (lightness >= 84)
    return getPrimaryPalette(
      tinycolor(primaryColor).darken(calibrateDark(lightness, 0.36)).toHexString(),
      { light: primaryColor }
    );
  if (lightness >= 61)
    return getPrimaryPalette(
      tinycolor(primaryColor).darken(calibrateDark(lightness, 0.24)).toHexString(),
      { base: primaryColor }
    );
  if (lightness < 43) {
    return getPrimaryPalette(
      tinycolor(primaryColor).lighten(calibrateLight(lightness, 0.32)).toHexString(),
      { darkest: primaryColor }
    );
  }
  return primaryPalette;
};
export {
  getPrimarySafePalette
};
